import moment from 'moment'

import { primary_color } from '../../../../Helper/uiHelper'
import { asLogRows, lockerEditHeadline, LockerLogDifference } from './lockerEditLog'

const defaultFields = [
  {
    field_id: 'item_id_label',
    label: 'Locker Name',
  },
  {
    field_id: 'location_id_label',
    label: 'Block Name',
  },
  {
    field_id: 'item_date_time_id_label',
    label: 'Academic Year',
  },
]

const headlineFor = (updatedRows, originalRows, isPaymentCompleted) => {
  if (isPaymentCompleted) {
    return lockerEditHeadline(updatedRows)
  }
  return ' has generated the payment request'
}

const ShowGenerated = ({ data, updated_data, onExpand, fields }) => {
  const rows = asLogRows(updated_data)
  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i className='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className='permission-header' style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {headlineFor(rows, null, false)}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='p-4'>
          {rows.map((row, index) => (
            <div key={row?.item_id_label || index}>
              <div className='p-4'>
                {fields?.map((item) => (
                  <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }} key={item.field_id}>
                    <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
                      {item?.label}:
                    </div>
                    <div style={{ width: '30%' }}>{row?.[item.field_id]}</div>
                  </div>
                ))}
              </div>
              <hr></hr>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const PaymentGenerated = ({ data, onExpand, expandedId, parentPageName, isPaymentCompleted }) => {
  const updated_data = data?.updated_data && JSON.parse(data.updated_data)
  const original_data = data?.original_data && JSON.parse(data.original_data)
  const rows = asLogRows(updated_data)
  const headline = headlineFor(rows, asLogRows(original_data), isPaymentCompleted)

  if (expandedId) {
    if (isPaymentCompleted) {
      return (
        <LockerLogDifference
          data={data}
          onExpand={onExpand}
          updated_data={updated_data}
          original_data={original_data}
          headline={headline}></LockerLogDifference>
      )
    }
    return <ShowGenerated data={data} onExpand={onExpand} updated_data={updated_data} fields={defaultFields}></ShowGenerated>
  }
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          className='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {headline}
      </div>

      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default PaymentGenerated
